// © Microsoft Corporation. All rights reserved.
/** The pdp query enums */
export var TargetType;
(function (TargetType) {
    /** Weather location */
    TargetType["Location"] = "Location";
    /** Finance */
    TargetType["Finance"] = "Finance";
    /** Sports team */
    TargetType["Team"] = "Team";
    /** Sports league */
    TargetType["League"] = "League";
    /** Sports layer */
    TargetType["Player"] = "Player";
})(TargetType || (TargetType = {}));
//# sourceMappingURL=TargetType.js.map